export default {
  methods: {
    getEstablecimiento() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var url = window.global.url + "establecimientos/" + idEstablecimiento;
      app.preloader.show();
      app.request.json(url, function (response) {
        if (response.code == 200) {
          var establecimiento = response.establecimiento;
          sessionStorage.setItem('_establecimiento', JSON.stringify(establecimiento));
          $('.titulo-nombre-establecimiento').text(establecimiento.nombre);
          app.preloader.hide();
        } else {
          app.preloader.hide();
          app.dialog.alert("Error");
        }
      }, function (xhr, status) {
        app.preloader.hide();
        console.log(xhr);
        console.log(status);
        app.dialog.alert("Error general");
      });
    },

    compartirFacebook() {
      let establecimiento = JSON.parse(sessionStorage.getItem("_establecimiento"));
      let link = establecimiento.url_personalizada;
      let url = 'https://www.facebook.com/sharer/sharer.php?u=' + link;

      if (link !== null || link == "") {
        let win = window.open(url, '_blank');
      }
    },

    compartirTwitter() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      let identity = JSON.parse(localStorage.getItem("usuario"));
      let establecimiento = JSON.parse(sessionStorage.getItem("_establecimiento"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento; // let url = "https://twitter.com/share?ref_src=twsrc%5Etfw";

      let text = 'Hola! mira nuestro menú digital en el siguiente link:';
      let link = establecimiento.url_personalizada;
      let hashtags = "webmenu,menudigital";
      let url = 'https://twitter.com/share?text=' + text + '&url=' + link + '&hashtags=' + hashtags;

      if (link !== null || link == "") {
        let win = window.open(url, '_blank');
      }
    },

    compartirWhatsapp() {
      let establecimiento = JSON.parse(sessionStorage.getItem("_establecimiento"));
      let link = establecimiento.url_personalizada;
      let message = 'Hola!, te invitamos a que mires nuestro menú digital en el siguiente link ' + link;
      let url = 'https://wa.me/?text=' + message;

      if (link !== null || link == "") {
        let win = window.open(url, '_blank');
      }
    },

    copiarLink() {
      var copyText = document.getElementById("inputUrlPersonalizada");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      alert("Copied the text: " + copyText.value);
    }

  },
  on: {
    pageBeforeIn() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var usuario = JSON.parse(localStorage.getItem('usuario'));
      $('.nombre-usuario').text(usuario.nombre);

      if (usuario.establecimientos.length > 1) {
        $('.left .back-button').removeClass('display-none');
      }
    },

    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var usuario = JSON.parse(localStorage.getItem('usuario'));
      self.getEstablecimiento(); //- Actions Grid

      var ac6 = app.actions.create({
        grid: true,
        buttons: [[{
          text: 'Facebook',
          icon: '<i class="icon fab fa-facebook text-color-blue"></i>',
          onClick: function () {
            self.compartirFacebook();
          }
        }, {
          text: 'Twitter',
          icon: '<i class="icon fab fa-twitter text-color-lightblue"></i>',
          onClick: function () {
            self.compartirTwitter();
          }
        }, {
          text: 'Whatsapp',
          icon: '<i class="icon fab fa-whatsapp text-color-green"></i>',
          onClick: function () {
            self.compartirWhatsapp();
          }
        } // {
        //     text: 'Copiar link',
        //     icon: '<i class="icon far fa-copy"></i>',
        //     onClick: function() {
        //         self.copiarLink();
        //     }
        // }
        ]]
      });
      $('.page[data-name="admin-principal"] .button-compartir').on('click', function () {
        ac6.open();
      });
      $('.page[data-name="admin-principal"] .button-ayuda').on('click', function () {
        window.open('https://webmenu.com.ar/manual', '_blank');
      });
      $('.descargar-pdf-button').on('click', function () {
        $('.descargar-pdf-button').addClass('disabled');
        app.preloader.show();
        window.open(window.global.url + 'pdf/menu/' + JSON.parse(sessionStorage.getItem('_establecimiento')).id_establecimiento, '_blank');
        setInterval(function () {
          $('.descargar-pdf-button').removeClass('disabled');
          app.preloader.hide();
        }, 4000);
      });
      $('.page[data-name="admin-principal"] .back-button').on('click', function () {
        if (usuario.establecimientos.length > 1) {
          app.views.main.router.navigate({
            name: 'admin-establecimientos-list'
          });
        } else {
          localStorage.clear();
          sessionStorage.clear();
          app.views.main.router.navigate({
            path: '/'
          });
        }
      });
    }

  },
  id: 'a0ec3f2c57',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=admin-principal><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class=navbar-inner><div class=left><a href=# class="link back-button display-none"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class=title>Webmenú</div><div class=right><a href=novedades class=link><i class="icon material-icons md-only">notifications</i> <i class="icon f7-icons ios-only ios-only">bell</i></a></div></div></div><!-- Scrollable page content--><div class=page-content><div class="row justify-content-center"><div class="col-100 medium-100 large-50"><div class=block><h2 class=titulo-nombre-establecimiento></h2><p>¡Hola, <span class=nombre-usuario></span>!</p></div><div class="block block-strong"><div class=row><p class=col><a href=carta class="button button-raised button-fill"><i class="icon fas fa-utensils"></i> Ver carta</a></p></div><div class=row><p class=col><a href=calificaciones class="button button-raised button-fill"><i class="icon fas fa-heart"></i> Calificaciones</a></p></div><div class=row><p class=col><a href=mis-datos class="button button-raised button-fill"><i class="icon fas fa-user"></i> Mis datos</a></p></div><div class=row><p class=col><a href=categorias/list class="button button-raised button-fill"><i class="icon fas fa-list-ul"></i> Categorías</a></p></div><div class=row><p class=col><a href=subcategorias/list class="button button-raised button-fill"><i class="icon fas fa-list-ul"></i> Subcategorías</a></p></div><div class=row><p class=col><a href=items/list class="button button-raised button-fill"><i class="icon fas fa-hamburger"></i> Productos</a></p></div><div class=row><p class=col><a href=ordenar-categorias class="button button-raised button-fill"><i class="icon fas fa-list-alt"></i> Ordenar categorías y productos</a></p></div><div class=row><p class=col><a href=# class="button button-raised button-fill descargar-pdf-button"><i class="icon fas fa-file-pdf"></i> Descargar carta PDF</a></p></div><div class=row><p class=col><a href=configuracion class="button button-raised button-fill"><i class="icon fas fa-cog"></i> Configuración</a></p></div><div class=row><p class=col><a href=# class="button button-compartir button-raised button-fill"><i class="icon fas fa-share-alt"></i> Compartir</a></p></div><div class=row><p class=col><a href=# class="button button-ayuda button-raised button-fill"><i class="icon fas fa-question-circle"></i> Ayuda</a></p></div></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `

`,
  styleScoped: false
};